export enum StreamApplication {
  LiveApp = 'LiveApp',
  WebRTCApp = 'WebRTCApp',
}
